import React from 'react';
import ModalAction from '@/components/ModalAction';
import CheckIcon from '@/images/icons/Check';
import LoaderIcon from '@/images/icons/Loader';
import { fetchAPI } from '@/api';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

const CancelModal = ({ modalOpen, setModalOpen, modalMessage, setModalMessage, setErrorModal, onSetSubscription, isConfirmed, setIsConfirmed }) => {
	const auth = useSelector(state => state.auth);

	const onClearModal = () => {
		setModalOpen(false);
		setTimeout(() => {
			setModalMessage(null);
			setErrorModal(null);
			setIsConfirmed(false);
		}, 400);
	};

	const onCancelSubscription = async () => {
		setIsConfirmed(true);
		setModalMessage(null);
		try {
			const response = await fetchAPI("/billing/cancel-subscription", auth.user.token);
			if (!response.ok) {
				throw new Error(`HTTP error: ${response.status}`);
			}

			const data = await response.json();

			if (data) {
				if (data.subscription) {
					onSetSubscription(data.subscription);
				}
				if (data.message) {
					setModalMessage(data.message);
				}
			}
		} catch (error) {
			console.error('Error fetching data:', error);
			let errorMessage = 'An unexpected error occurred';
			if (error.response?.message) {
				errorMessage = error.response.message;
			}
			setErrorModal(errorMessage);
			setIsConfirmed(false);
		}
	};

	return (
		<ModalAction
			id="cancel-modal"
			modalOpen={modalOpen}
			setModalOpen={setModalOpen}
			onModalClose={() => onClearModal()}
			size="sm"
		>
			<h2 className="h2 mb-4 pr-16 md:pr-20 leading-[0.9]">
				{modalMessage ? (
					<div dangerouslySetInnerHTML={{ __html: modalMessage }} />
				) : (
					<div className="flex flex-col gap-1">
						<div className="animate-pulse bg-[#F2F2F2] rounded-full w-3/4 h-4 sm:h-3 sm:mt-1.5 inline-block" />
						<div className="animate-pulse bg-[#F2F2F2] rounded-full w-1/4 h-4 sm:h-3 sm:mt-1.5 inline-block" />
					</div>
				)}
			</h2>
			<button className={classNames(
				'btn-primary w-full mt-8',
				!isConfirmed && 'hidden',
				!modalMessage && 'pointer-events-none',
			)} onClick={() => onClearModal()}>
				{modalMessage ? (
					<div className="flex items-center justify-center py-1 pointer-events-none">
						<CheckIcon className="w-6 h-5 text-white" />
					</div>
				) : (
					<div className="flex items-center justify-center py-1 pointer-events-none">
						<LoaderIcon className="animate-rotation w-6 h-6 text-white" />
					</div>
				)}
			</button>
			<div className={classNames(
				isConfirmed && 'hidden',
			)}>
				<button className="btn-primary w-full mt-8" onClick={() => onClearModal()}>
					<span className="pointer-events-none">Save</span>
				</button>
				<button className="btn-primary-inverted w-full mt-4" onClick={() => onCancelSubscription()}>
					<span className="pointer-events-none">Cancel whatever</span>
				</button>
			</div>
		</ModalAction>
	);
};

export default CancelModal;
